/* eslint-disable @typescript-eslint/no-empty-function */
import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

export interface GuestDetails {
  title: string;
  relationship_type: string;
  guest_first_name: string;
  guest_last_name: string;
}
export interface ChildrenDetails {
  childFirstName: string;
  childLastName: string;
  childAge: string;
  childNotesArea: string;
}

export interface PetDetails {
  petName: string;
  petBreed: string;
  petNotesArea: string;
}
export interface CreateSurveyState {
  formData: {
    non_brand_flg: string;
    favIcon: string;
    brandCode: string;
    marshaCode: string;
    marsha_cd: string;
    confirmationNumber: string;
    userName: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    amenities: [] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    property_config: [] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reservation: [] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    passions: [] | any;
    reservation_num: string;
    brand_name: string;
    guest_first_name: string;
    guest_last_name: string;
    guest_bonvoy_number: string;
    guest_acid: string;
    check_in_date: string;
    check_out_date: string;
    timezone_of_guest: string;
    additional_guests_exists: string;
    traveling_with_children: string;
    add_additional_guest: string;
    accessibilityNeeds_toggle: string;
    specialOccasion_toggle: string;
    accessibility_notes: string;
    traveling_with_pets: string;
    accessiblity_needs: string;

    transportation_arrival_time: string;
    need_arrival_departure_assistance: string;
    arrival_method: string;
    arrival_method_toggle: string;
    arrival_method_innertoggle: string;
    transportation_method_toggle: string;
    additional_requests_toggle: string;
    transportation_arrival_date: string;
    arrival_anticipate_time: string;
    transportation_departure_date: string;
    departure_method: string;
    transportation_departure_time: string;
    arrival_dept_notes: string;
    special_occasion_request: string;
    special_occasion_request_other: string;
    special_occasion_request_other_notes: string;
    special_occasion_request_notes: string;
    additional_requests: string;
    surprise_request: string;
    other_dining_detail: [];

    dietary_restrictions: string;
    dining_dietary_restrictions_notes: string;
    dietary_restrictions_notes: string;
    dining_notes: string;
    other_experiences_notes: string;
    other_experiences_check: boolean;
    tripEmailCheckbox: boolean;
    tripPhoneCheckbox: boolean;
    tripTextCheckbox: boolean;
    tripWechatCheckbox: boolean;
    tripWhatsappCheckbox: boolean;
    appView: boolean;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    additional_guests_details: GuestDetails | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children_details: ChildrenDetails | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    pet_details: PetDetails | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    accessiblity_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    special_occasion_request_category_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    preferred_contact_method_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    surprise_request_coordination_contact_detail: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dining_plan_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    experiences_plan_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    other_experiences_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    other_dining_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    tip_checked_details: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dietary_restrictions_details: string[] | any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    survey_responses: string[] | any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    prearrivalformamenitiesaddedtoplan: string[] | any;
    isNavError: boolean;
    isShowVariableErrorMessage: boolean;
    petFeeCatalogData: string;
    arrivalInfo: string;
    arrivalFlightNumber: string;
    arrivalPassengers: string;
    departureInfo: string;
    departureFlightNumber: string;
    departurePassengers: string;
    consentCheckbox: boolean;
    isSignInDrawerOpen: boolean;
    isSignInDrawerSideBarOpen: boolean;
    isSubmitDataFlow: boolean;
    isReviewPageFlow: boolean;
    isUserLoggedInReviewPage: boolean;
    isUserConsentChecked: boolean;
    isUserEnableSignIn: boolean;
    isTPFAlreadySubmitted: boolean;
    isSignInFeatureDisable: boolean;
    isRememberUser: boolean;
    isCloseSignInModalOnSubmit: boolean;
    isFormReadyForThankYou: boolean;
    isSaveConsentCall: boolean;
    isMFAActive: boolean;
    isThankYouPageLoad: boolean;
  };
  isFormValid: boolean;
  validateForm: () => boolean;
  formValidation: boolean;
  setFormValidation: (value: boolean) => void;
  errorKey: string[];
  setErrorKey: (value: string[]) => void;
  consents: { type: string; optin: boolean; ctype: string }[];
  setConsents: (consents: { type: string; optin: boolean; ctype: string }[]) => void;
  joinNowEnabled: boolean;
  setJoinNowEnabled: (value: boolean) => void;
  joinNowBtnClicked: boolean;
  setJoinNowBtnClicked: (value: boolean) => void;
  remembermeCheckBox: boolean;
  setRemembermeCheckBox: (value: boolean) => void;
  errorsList: string[];
  setErrorsList: (errors: string[]) => void;
  setFormData: (data: Partial<CreateSurveyState['formData']>) => void;
  checkedItems: {
    key?: string;
    checkboxId: string;
    checked: boolean;
  }[];
  setCheckedItems: (checkedItems: { key?: string; checkboxId: string; checked: boolean }[]) => void;
  initialCheckedItems: {
    key?: string;
    checkboxId: string;
    checked: boolean;
  }[];
  setIntitalCheckedItems: (checkedItems: { key?: string; checkboxId: string; checked: boolean }[]) => void;
  loadFromSessionStorage: () => void;
  totalPoint: number;
  form_prearrival_questions_complete: string;
  setTotalPoint: () => void;
}
const initialState: CreateSurveyState = {
  formData: {
    non_brand_flg: '',
    favIcon: '',
    brandCode: '',
    marshaCode: '',
    marsha_cd: '',
    confirmationNumber: '',
    userName: '',
    amenities: [],
    property_config: [],
    reservation: [],
    passions: [],
    reservation_num: '',
    brand_name: '',
    guest_first_name: '',
    guest_last_name: '',
    guest_bonvoy_number: '',
    guest_acid: '',
    check_in_date: '',
    check_out_date: '', // Add check_out_date property
    timezone_of_guest: '',
    additional_guests_exists: '',
    traveling_with_children: '',
    add_additional_guest: '',
    accessibilityNeeds_toggle: '',
    specialOccasion_toggle: '',
    accessibility_notes: '',
    traveling_with_pets: '',
    accessiblity_needs: '',
    transportation_arrival_time: '',
    need_arrival_departure_assistance: 'No',
    arrival_method: '',
    arrival_method_toggle: '',
    arrival_method_innertoggle: '',
    transportation_method_toggle: '',
    transportation_arrival_date: '',
    arrival_anticipate_time: '',

    transportation_departure_date: '',
    departure_method: '',

    transportation_departure_time: '',
    arrival_dept_notes: '',
    special_occasion_request: '',
    special_occasion_request_other: '',
    special_occasion_request_other_notes: '',
    special_occasion_request_notes: '',
    additional_requests: '',
    additional_requests_toggle: '',
    surprise_request: '',
    other_dining_detail: [], // Correct property name from other_dining_details to other_dining_detail
    dietary_restrictions: '',
    dining_dietary_restrictions_notes: '',
    dietary_restrictions_notes: '',
    dining_notes: '',
    other_experiences_notes: '',
    other_experiences_check: false,
    additional_guests_details: [],
    children_details: [],
    pet_details: [],
    accessiblity_details: [],
    special_occasion_request_category_details: [],
    preferred_contact_method_details: [],
    surprise_request_coordination_contact_detail: [],
    dining_plan_details: [],
    experiences_plan_details: [],
    other_experiences_details: [],
    other_dining_details: [], // Add other_dining_details property
    tip_checked_details: [],
    dietary_restrictions_details: [],
    survey_responses: [],
    tripEmailCheckbox: false,
    tripPhoneCheckbox: false,
    tripTextCheckbox: false,
    tripWechatCheckbox: false,
    tripWhatsappCheckbox: false,
    prearrivalformamenitiesaddedtoplan: [],
    isNavError: false,
    isShowVariableErrorMessage: false,
    petFeeCatalogData: 'Y',
    appView: false,
    arrivalInfo: '',
    arrivalFlightNumber: '',
    arrivalPassengers: '',
    departureInfo: '',
    departureFlightNumber: '',
    departurePassengers: '',
    consentCheckbox: false,
    isSignInDrawerOpen: false,
    isSignInDrawerSideBarOpen: false,
    isSubmitDataFlow: false,
    isReviewPageFlow: false,
    isUserLoggedInReviewPage: false,
    isUserConsentChecked: false,
    isUserEnableSignIn: false,
    isTPFAlreadySubmitted: false,
    isSignInFeatureDisable: false,
    isRememberUser: false,
    isCloseSignInModalOnSubmit: false,
    isFormReadyForThankYou: false,
    isSaveConsentCall: false,
    isMFAActive: false,
    isThankYouPageLoad: false,
  },
  isFormValid: false,
  validateForm: () => false,
  formValidation: false,
  setFormValidation: () => {},
  errorKey: [],
  setErrorKey: () => {},
  consents: [
    { type: 'CORE_REQUIRED_CONSENT', optin: false, ctype: 'userConsents' },
    { type: 'PERSONALIZED_MARKETING_CONSENT', optin: false, ctype: 'userConsents' },
    { type: 'subscriptionsOffers', optin: false, ctype: 'communicationPerferences' },
    { type: 'subscriptions3rdParty', optin: false, ctype: 'communicationPerferences' },
  ],
  setConsents: () => {},
  joinNowEnabled: false,
  setJoinNowEnabled: () => {},
  joinNowBtnClicked: false,
  setJoinNowBtnClicked: () => {},
  remembermeCheckBox: true,
  setRemembermeCheckBox: () => {},
  errorsList: [],
  setErrorsList: () => {},
  setFormData: () => {},
  checkedItems: [],
  setCheckedItems: () => {},
  initialCheckedItems: [],
  setIntitalCheckedItems: () => {},
  loadFromSessionStorage: () => {},
  totalPoint: 0,
  form_prearrival_questions_complete: '',
  setTotalPoint: () => {},
};

const createSurveyStore: StateCreator<CreateSurveyState> = (set, get) => ({
  ...initialState,
  setConsents: (consents: { type: string; optin: boolean; ctype: string }[]) => {
    set(() => ({
      consents,
    }));
  },
  setJoinNowEnabled: (value: boolean) => {
    set(() => ({
      joinNowEnabled: value,
    }));
  },
  setFormValidation: (value: boolean) => {
    set(() => ({
      formValidation: value,
    }));
  },
  validateForm: () => {
    const { formData } = get();
    let isValid = true;
    if (formData?.need_arrival_departure_assistance === 'Yes') {
      if (
        formData?.arrival_anticipate_time != '' &&
        formData?.arrival_method != '' &&
        formData?.departure_method != '' &&
        formData.transportation_arrival_date != '' &&
        formData.transportation_departure_date != '' &&
        formData.transportation_arrival_time != '' &&
        formData.transportation_departure_time != ''
      ) {
        isValid = true;
      } else {
        isValid = false;
      }
    } else {
      if (formData?.arrival_anticipate_time != '') {
        isValid = true;
      } else {
        isValid = false;
      }
    }
    //1. check the check box is check or not
    // 2. checked phone Number filed with data or not
    // 3. check the time zone select or not
    // 4. need check other all options
    const contactMethods = formData?.preferred_contact_method_details || [];
    const validateContact = (type: string) => {
      const entry = contactMethods.find((item: { contact_method_type: string }) => item.contact_method_type === type);

      return (entry && entry.contact_method_detail !== '' && entry.timezone_of_guest !== 'Select') || '';
    };

    // Validate only enabled checkboxes
    if (formData?.tripPhoneCheckbox && !validateContact('phone')) {
      isValid = false;
    }

    if (formData?.tripTextCheckbox && !validateContact('text')) {
      isValid = false;
    }

    if (formData?.tripWechatCheckbox && !validateContact('wechat')) {
      isValid = false;
    }

    if (formData?.tripWhatsappCheckbox && !validateContact('whatsapp')) {
      isValid = false;
    }
    set({ isFormValid: isValid });
    return isValid;
  },
  setTotalPoint: () => {
    // get the value from formData
    const { formData } = get();

    //initialize the point
    let calTotalPoints = 0;

    //check and add points
    //guest details points
    const guests = formData.additional_guests_details || [];
    let guestPoints = 0;
    let guestCompletePercentage = 0;

    // check there is guest data added
    if (guests.length > 0) {
      guestPoints += 1;
      // check if relation added in guest data
      guests.forEach((guest: GuestDetails) => {
        if (guest.relationship_type.trim()) {
          guestPoints += 1; // Add 1 point if `relationship_type` is provided
        }
      });
    }

    // Ensure max points for guests do not exceed 2
    guestPoints = Math.min(guestPoints, 2);
    calTotalPoints += guestPoints;
    guestCompletePercentage = guestPoints > 0 ? (guestPoints / 2) * 100 : 0;

    // child section points
    const children = formData.children_details || [];
    let childrenPoints = 0;
    let childCompletePercentage = 0;
    let firstNameAndLastNameCheck = 0;

    // check there is any child data added
    if (children.length > 0) {
      childrenPoints += 1;
      // check if relation added in guest data
      children.forEach((child: ChildrenDetails) => {
        if (child.childFirstName.trim() || child.childLastName.trim()) {
          firstNameAndLastNameCheck = 1; // Add 1 point if `relationship_type` is provided
        }
      });
      childrenPoints += firstNameAndLastNameCheck;
      children.forEach((child: ChildrenDetails) => {
        if (child.childAge.trim()) {
          childrenPoints += 1;
        }
      });
      children.forEach((child: ChildrenDetails) => {
        if (child.childNotesArea.trim()) {
          childrenPoints += 1;
        }
      });
    }

    // Ensure max points for child do not exceed 4
    childrenPoints = Math.min(childrenPoints, 4);
    calTotalPoints += childrenPoints;
    childCompletePercentage = childrenPoints > 0 ? (childrenPoints / 4) * 100 : 0;

    // pet section points
    const pets = formData.pet_details || [];
    let petPoints = 0;
    let petCompletePercentage = 0;
    // check there is any pet data added
    if (pets.length > 0) {
      petPoints += 1;
      // check if relation added in guest data
      pets.forEach((pet: PetDetails) => {
        if (pet.petName.trim()) {
          petPoints += 1; // Add 1 point if `relationship_type` is provided
        }
      });
      pets.forEach((pet: PetDetails) => {
        if (pet.petBreed.trim()) {
          petPoints += 1;
        }
      });
      pets.forEach((pet: PetDetails) => {
        if (pet.petNotesArea.trim()) {
          petPoints += 1;
        }
      });
    }

    // Ensure max points for child do not exceed 4
    petPoints = Math.min(petPoints, 4);
    calTotalPoints += petPoints;
    petCompletePercentage = petPoints > 0 ? (petPoints / 4) * 100 : 0;

    // accessibility section point
    const accessibilityData = formData.accessiblity_details || [];
    let accessibilityPoints = 0;
    let accessibilityCompletePercentage = 0;
    if (formData.accessiblity_needs.trim() === 'Yes') {
      accessibilityPoints += 1;
      if (accessibilityData.length > 0) {
        accessibilityPoints += 1;
      }
      if (formData.accessibility_notes.trim()) {
        accessibilityPoints += 1;
      }
    }

    // Ensure max points for accessibility do not exceed 3
    accessibilityPoints = Math.min(accessibilityPoints, 3);
    calTotalPoints += accessibilityPoints;
    accessibilityCompletePercentage = accessibilityPoints > 0 ? (accessibilityPoints / 3) * 100 : 0;

    // trip contact preference section point
    const tripContactPreference = formData.preferred_contact_method_details || [];
    let tripPreferencePoints = 0;
    let tripPreferenceCompletePercentage = 0;

    if (tripContactPreference.length > 1) {
      tripPreferencePoints += 1;
    }

    // Ensure max points for trip do not exceed 1
    tripPreferencePoints = Math.min(tripPreferencePoints, 1);
    calTotalPoints += tripPreferencePoints;
    tripPreferenceCompletePercentage = tripPreferencePoints > 0 ? (tripPreferencePoints / 1) * 100 : 0;

    // special occasion section points
    const specialOccassion = formData.special_occasion_request;
    let specialOccassionePoints = 0;
    let specialOccassioneCompletePercentage = 0;

    if (specialOccassion === 'Yes') {
      specialOccassionePoints += 1;
      if (formData.special_occasion_request_other_notes.trim()) {
        specialOccassionePoints += 1;
      }
    }

    // Ensure max points for special do not exceed 2
    specialOccassionePoints = Math.min(specialOccassionePoints, 2);
    calTotalPoints += specialOccassionePoints;
    specialOccassioneCompletePercentage = specialOccassionePoints > 0 ? (specialOccassionePoints / 2) * 100 : 0;

    // special occasion section points
    const transportationDetail = formData.need_arrival_departure_assistance;
    let transportationPoints = 0;
    let transportationCompletePercentage = 0;

    if (transportationDetail === 'Yes') {
      transportationPoints += 1;
      if (formData.arrival_dept_notes.trim()) {
        transportationPoints += 1;
      }
    }

    // Ensure max points for special do not exceed 2
    transportationPoints = Math.min(transportationPoints, 2);
    calTotalPoints += transportationPoints;
    transportationCompletePercentage = transportationPoints > 0 ? (transportationPoints / 2) * 100 : 0;

    //additional notes
    let additionalRequestPoints = 0;
    let additionalRequestCompletePercentage = 0;
    if (formData.additional_requests.trim()) {
      additionalRequestPoints += 1;
    }

    // Ensure max points for special do not exceed 2
    additionalRequestPoints = Math.min(additionalRequestPoints, 1);
    calTotalPoints += additionalRequestPoints;
    additionalRequestCompletePercentage = additionalRequestPoints > 0 ? (additionalRequestPoints / 1) * 100 : 0;

    // dining points
    const diningDetails = formData.dining_plan_details || [];
    let diningPoints = 0;
    let diningCompletePercentage = 0;

    if (diningDetails.length > 0) {
      diningPoints += 1;
    }

    // check if other is selected any value
    if (formData.other_dining_details.length > 0) {
      diningPoints += 1;
    }

    if (formData.dietary_restrictions_details.length > 0) {
      diningPoints += 1;
    }

    // Ensure max points for special do not exceed 3
    diningPoints = Math.min(diningPoints, 3);
    calTotalPoints += diningPoints;
    diningCompletePercentage = diningPoints > 0 ? (diningPoints / 3) * 100 : 0;

    //experience points
    const experienceDetails = formData.experiences_plan_details || [];
    let experiencePoints = 0;
    let experienceCompletePercentage = 0;

    if (experienceDetails.length > 0) {
      experiencePoints += 1;
    }

    if (formData.other_experiences_details.length > 0) {
      experiencePoints += 1;
    }

    if (formData.dietary_restrictions_notes.trim()) {
      experiencePoints += 1;
    }

    // Ensure max points for special do not exceed 3
    experiencePoints = Math.min(experiencePoints, 3);
    calTotalPoints += experiencePoints;
    experienceCompletePercentage = experiencePoints > 0 ? (experiencePoints / 3) * 100 : 0;

    let completePercentageText = '';

    if (guestPoints > 0) {
      completePercentageText += `form_name_guestdetail:${Math.round(guestCompletePercentage)}|`;
    }

    if (childrenPoints > 0) {
      completePercentageText += `form_name_children:${Math.round(childCompletePercentage)}|`;
    }

    if (petPoints > 0) {
      completePercentageText += `form_name_pet:${Math.round(petCompletePercentage)}|`;
    }

    if (accessibilityPoints > 0) {
      completePercentageText += `form_name_accessibility:${Math.round(accessibilityCompletePercentage)}|`;
    }

    if (tripPreferencePoints > 0) {
      completePercentageText += `form_name_tripPreference:${Math.round(tripPreferenceCompletePercentage)}|`;
    }

    if (specialOccassionePoints > 0) {
      completePercentageText += `form_name_specialOccassion:${Math.round(specialOccassioneCompletePercentage)}|`;
    }

    if (transportationPoints > 0) {
      completePercentageText += `form_name_transportation:${Math.round(transportationCompletePercentage)}|`;
    }

    if (additionalRequestPoints > 0) {
      completePercentageText += `form_name_additionalRequest:${Math.round(additionalRequestCompletePercentage)}|`;
    }

    if (diningPoints > 0) {
      completePercentageText += `form_name_dining:${Math.round(diningCompletePercentage)}|`;
    }

    if (experiencePoints > 0) {
      completePercentageText += `form_name_experience:${Math.round(experienceCompletePercentage)}`;
    }

    let completePtsPercentage = 0;
    let totalPts = 25;

    if (formData.property_config?.adults_only_flag === 'Y') {
      totalPts -= 4;
    }
    if (formData.petFeeCatalogData === 'N') {
      totalPts -= 4;
    }

    completePtsPercentage = calTotalPoints > 0 ? (calTotalPoints / totalPts) * 100 : 0;
    //completePtsPercentage = calTotalPoints > 0 ? calTotalPoints : 0;

    // update the store with the calculated points
    set(() => ({ totalPoint: calTotalPoints }));
    set(() => ({
      form_prearrival_questions_complete: `${Math.round(calTotalPoints)}|${totalPts}|${Math.round(
        completePtsPercentage
      )}`,
    }));
  },
  setErrorKey: (value: string[]) => {
    set(() => ({
      errorKey: value,
    }));
  },
  setFormData: (data: Partial<CreateSurveyState['formData']>) => {
    set((state: CreateSurveyState) => ({
      formData: {
        ...state.formData,
        ...data,
      },
    }));
  },
  setJoinNowBtnClicked: (value: boolean) => {
    set({ joinNowBtnClicked: value });
  },
  setRemembermeCheckBox: (value: boolean) => {
    set({ remembermeCheckBox: value });
  },
  setErrorsList: (errors: string[]) => {
    set(() => ({
      errorsList: errors,
    }));
  },
  setCheckedItems: (checkedItems: { key?: string; checkboxId: string; checked: boolean }[]) => {
    set(() => ({
      checkedItems,
    }));
  },
  setIntitalCheckedItems: (initialCheckedItems: { key?: string; checkboxId: string; checked: boolean }[]) => {
    set(() => ({
      initialCheckedItems,
    }));
  },
  loadFromSessionStorage: () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const savedFormData: any = sessionStorage.getItem('prearrivalSurveyFormState');
    if (savedFormData) {
      const sessionData = JSON.parse(savedFormData).state?.formData;
      console.log('formData loading from sessions storage', sessionData);
      set((state: CreateSurveyState) => ({
        formData: {
          ...state.formData,
          sessionData,
        },
      }));
    }
  },
});
export const useCreateSurveyStore = createAppStore(createSurveyStore, {
  usePersistentStore: true,
  persistentStoreName: 'prearrivalSurveyFormState',
});
